export const MAIN_MENU_ANIMATION_DURATION = 300;
